// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tooltip-with-icon_wrapper__GNLsz","icon":"tooltip-with-icon_icon__Xy7cB","inner":"tooltip-with-icon_inner__IEUq5"};